let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("tpsMe")).then(() => parcelRequire('ay7Tg'));